<template>
  <div :class="['v-spinner', spinnerSize, spinnerVariant]">&nbsp;</div>
</template>

<script>
const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg"
});

const variants = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  DANGER: "danger",
  WARNING: "warning",
  INFO: "info",
  LIGHT: "light"
});

export default {
  name: "Spinner",
  props: {
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    variant: {
      type: String,
      validator: value => Object.values(variants).includes(value),
      default: variants.PRIMARY
    }
  },
  computed: {
    spinnerSize() {
      return `v-spinner-${this.size}`;
    },
    spinnerVariant() {
      return `v-spinner-${this.variant}`;
    }
  }
};
</script>
